// Applies blur filter to an element so age gated users get a sense of the content,
// but not enough to see much of what's going on. Uses viewport-relative units to
// prevent content becoming more-or-less-visible in a sufficiently large window.
export function cssBlurElement(el: HTMLElement): void {
    el.style.filter = "blur(3vmax)"
}

// Re-applies the blur effect on a given interval to hinder devtools tampering
export function setBlurInterval(selector: string, interval: number = 500): void {
    window.setInterval(() => {
        document.querySelectorAll<HTMLElement>(selector).forEach((el) => {
            cssBlurElement(el)
        })
    }, interval)
}
